"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { getRandomObjectId } from "@/helpers/AllowlistToolHelpers";
import { formatNumberWithCommasOrDash, getTimeAgo } from "@/helpers/Helpers";
import type { DistributionTableItem } from "./UserPageStatsActivityDistributionsTable";
import { DistributionCollection } from "./UserPageStatsActivityDistributionsTable";
import { useEffect, useState } from "react";
export default function UserPageStatsActivityDistributionsTableItem(t0) {
  const $ = _c(35);
  const {
    item
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      [DistributionCollection.MEMES]: "The Memes",
      [DistributionCollection.GRADIENTS]: "6529Gradient",
      [DistributionCollection.MEMELAB]: "Meme Lab"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const COLLECTION_TO_TEXT = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      [DistributionCollection.MEMES]: "/the-memes",
      [DistributionCollection.GRADIENTS]: "/6529-gradient",
      [DistributionCollection.MEMELAB]: "/meme-lab"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const COLLECTION_TO_PATH = t2;
  const [timeAgo, setTimeAgo] = useState("");
  let t3;
  if ($[2] !== item.date) {
    t3 = () => {
      setTimeAgo(getTimeAgo(new Date(item.date).getTime()));
    };
    $[2] = item.date;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [];
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  useEffect(t3, t4);
  const t5 = COLLECTION_TO_TEXT[item.collection];
  let t6;
  if ($[5] !== t5) {
    t6 = <td className="tw-text-iron-400 tw-py-3.5 tw-font-medium tw-px-4 sm:tw-px-6 lg:tw-pr-4 tw-whitespace-nowrap tw-text-sm sm:tw-text-base">{t5}</td>;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = `${COLLECTION_TO_PATH[item.collection]}/${item.tokenId}`;
  let t8;
  if ($[7] !== item.tokenId || $[8] !== t7) {
    t8 = <td className="tw-py-3.5 tw-font-medium tw-px-4 sm:tw-px-6 lg:tw-pl-4 tw-text-right tw-whitespace-nowrap tw-text-sm sm:tw-text-base"><Link className="tw-no-underline hover:tw-underline tw-text-iron-50" href={t7}># {item.tokenId}</Link></td>;
    $[7] = item.tokenId;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== item.name) {
    t9 = <td className="tw-text-iron-50 tw-py-3.5 tw-font-medium tw-px-4 sm:tw-px-6 lg:tw-pl-4 tw-whitespace-nowrap tw-text-sm sm:tw-text-base">{item.name}</td>;
    $[10] = item.name;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== item.wallet) {
    t10 = <td className="tw-text-iron-400 tw-py-3.5 tw-font-normal tw-px-4 sm:tw-px-6 lg:tw-pl-4 tw-whitespace-nowrap tw-text-sm sm:tw-text-base">{item.wallet}</td>;
    $[12] = item.wallet;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== item.phases) {
    t11 = item.phases.map(_temp);
    $[14] = item.phases;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== item.amountMinted) {
    t12 = formatNumberWithCommasOrDash(item.amountMinted);
    $[16] = item.amountMinted;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t12) {
    t13 = <td className="tw-text-iron-400 tw-py-3.5 tw-font-normal tw-px-4 sm:tw-px-6 lg:tw-pl-4 tw-whitespace-nowrap tw-text-sm sm:tw-text-base tw-text-right">{t12}</td>;
    $[18] = t12;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== item.amountTotal) {
    t14 = formatNumberWithCommasOrDash(item.amountTotal);
    $[20] = item.amountTotal;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== t14) {
    t15 = <td className="tw-text-iron-400 tw-py-3.5 tw-font-normal tw-px-4 sm:tw-px-6 lg:tw-pl-4 tw-whitespace-nowrap tw-text-sm sm:tw-text-base tw-text-right">{t14}</td>;
    $[22] = t14;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== timeAgo) {
    t16 = <td className="tw-text-iron-500 tw-py-3.5 tw-font-normal tw-px-4 sm:tw-px-6 lg:tw-pl-4 tw-whitespace-nowrap tw-text-sm sm:tw-text-base tw-text-right">{timeAgo}</td>;
    $[24] = timeAgo;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== t10 || $[27] !== t11 || $[28] !== t13 || $[29] !== t15 || $[30] !== t16 || $[31] !== t6 || $[32] !== t8 || $[33] !== t9) {
    t17 = <tr className="even:tw-bg-iron-900">{t6}{t8}{t9}{t10}{t11}{t13}{t15}{t16}</tr>;
    $[26] = t10;
    $[27] = t11;
    $[28] = t13;
    $[29] = t15;
    $[30] = t16;
    $[31] = t6;
    $[32] = t8;
    $[33] = t9;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  return t17;
}
function _temp(phase) {
  return <td key={getRandomObjectId()} className="tw-text-iron-400 tw-py-3.5 tw-font-normal tw-px-4 tw-text-right sm:tw-px-6 lg:tw-pl-4 tw-whitespace-nowrap tw-text-sm sm:tw-text-base">{formatNumberWithCommasOrDash(phase)}</td>;
}